import React from 'react';
import { BaseIcon } from './BaseIcon';

export const DownloadJobZipFileIcon: React.FC = () => {
  return (
    <BaseIcon
      title="Download Job Zip File"
      paths={{
        d: 'M10 3v4a1 1 0 0 1-1 1H5m14-4v16a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V7.914a1 1 0 0 1 .293-.707l3.914-3.914A1 1 0 0 1 9.914 3H18a1 1 0 0 1 1 1Zm-4 1h.01v.01H15V5Zm-2 2h.01v.01H13V7Zm2 2h.01v.01H15V9Zm-2 2h.01v.01H13V11Zm2 2h.01v.01H15V13Zm-2 2h.01v.01H13V15Zm2 2h.01v.01H15V17Zm-2 2h.01v.01H13V19Z',
        strokeLinecap: 'round',
      }}
    />
  );
};
